export default {
    // Form validation messages
    'is_required': 'is required',
    'this_field_is_required': 'This field is required',
    'required_field': 'Required field',
    'valid_email_address_is_required': 'Valid email address is required',
    'valid_phone_number_required': 'Valid phone number required',
    
    // Form buttons and actions
    'book_now': 'Book Now',
    'request_appointment': 'Request Appointment',
    'select_dropdown': 'Select >',
    
    // Date picker
    'day': 'Day',
    'month': 'Month',
    'year': 'Year',
    'month_jan': '1 - Jan',
    'month_feb': '2 - Feb', 
    'month_mar': '3 - Mar',
    'month_apr': '4 - Apr',
    'month_may': '5 - May',
    'month_jun': '6 - Jun',
    'month_jul': '7 - Jul',
    'month_aug': '8 - Aug',
    'month_sep': '9 - Sep',
    'month_oct': '10 - Oct',
    'month_nov': '11 - Nov',
    'month_dec': '12 - Dec',
    
    // Error messages
    'unknown_field_type': 'Unknown field type:',
    'sorry_we_encountered_an_error': 'Sorry! We encountered an error:',
    
    // Booking interface
    'select_a_location': 'Select a Location',
    'select_appointment_type': 'Select Appointment Type',
    'any_eye_doctor': 'Any Eye Doctor',
    'more': 'More +',
    'previous': 'Previous',
    'next': 'Next',
    'call_us': 'Call Us',
    
    // Modal success page
    'success': 'Success!',
    'welcome_new_patients': '🎉 &nbsp; Welcome, We Love New Patients!',
    'welcome_back': '👋 &nbsp; Welcome Back!',
    'your_appointment_has_been_booked': 'Your appointment has been booked.',
    'appointment_request_received': 'Appointment request received. <br>We will confirm shortly.',
    'add_to_calendar': 'Add to Calendar',
    'easily_book_another_family_member': 'Easily book another family member now:',
    'about_me': 'About Me',
    'back_to_booking': 'Back to Booking',
    'questions_call_us': 'Questions? Call us at',
    'any_questions_call_us': 'Any Questions? Call Us',
    'help_call_us': 'Help?: Call Us',
    'help_call': 'Help?: Call',
    
    // Accessibility labels
    'select_location': 'Select Location',
    'select_any_eye_doctor': 'Select Any Eye Doctor',
    'show_more_bookings': 'Show More Bookings',
    'navigate_to_previous_week': 'Navigate to previous week',
    'navigate_to_next_week': 'Navigate to next week',
    'book_time': 'Book',
    'view_doctor_details': 'View doctor details',
    'close': 'Close',
    'close_doctor_modal': 'Close doctor modal',
    'focus_appointment_modal_close_button': 'Focus appointment modal close button',
    'focus_doctor_modal_close_button': 'Focus doctor modal close button',
    
    // Loading and fallbacks
    'loading': 'Loading...',
    'no_account_id': 'No Account ID',
    'slot_not_found': 'Slot not found',
    
    // Form schema labels (default_schema only)
    'new_or_returning_patient': 'New or Returning Patient',
    'new': 'New',
    'returning': 'Returning',
    'appointment_type': 'Appointment Type',
    'legal_first_name': 'Legal First Name',
    'last_name': 'Last Name',
    'email': 'Email',
    'email_description': 'You agree to get emails. Click "Unsubscribe" to opt out.',
    'phone': 'Phone',
    'phone_description': 'You agree to get texts.  Reply "STOP" to opt out.',
    'health_card_number': 'Health Card Number',
    'date_of_birth': 'Date of Birth',
    'insurance_benefits': 'Insurance Benefits',
    'yes': 'Yes',
    'no': 'No',
    'insurance_company_vision_plan': 'Insurance Company / Vision Plan',
    'policy_holder_name': 'Policy Holder Name',
    'policy_id_number': 'Policy ID Number',
    'last_4_digits_of_ssn': 'Last 4 Digits of SSN',
    'policy_holder_birthdate': "Policy Holder's Birthdate",
    
    // Additional schema labels for custom forms
    'address': 'Address',
    'address_2': 'Address 2',
    'city': 'City',
    'state_province': 'State/Province',
    'state': 'State',
    'country': 'Country',
    'postal_code': 'Postal Code',
    'zip': 'Zip',
    'policy_number': 'Policy Number',
    'member_id': 'Member ID',
    'vision_insurance': 'Vision Insurance?',
    'medical_insurance': 'Medical Insurance?',
    'insurance_type_vision_medical': 'Insurance type, Vision or Medical?',
    'your_current_insurance_provider': 'Your current insurance provider',
    'primary_insurance_holder_name': "Primary Insurance Holder's First and Last Name",
    'primary_insurance_holder_birthdate': "Primary Insurance Holder's Date of Birth",
    'your_current_plan_number': 'Your current plan number',
    'primary_insurance_holder_ssn': "Primary Insurance Holder's Social Security Number (Last 4 Digits)",
    'are_you_planning_on_using_insurance': 'Are you planning on using insurance for this visit?',
    'group_number': 'Group Number',
    'phone_type': 'Phone Type',
    'mobile': 'Mobile',
    'home': 'Home',
    'anything_else_office_should_know': 'Is there anything else our office should know about this visit?',
    'do_you_have_contacts_plan_getting': 'Do you have contacts or plan on getting them?',
    'do_you_wear_contact_lenses': 'Do you wear contact lenses?',
    'gender': 'Gender',
    'when': 'When:',
    'where': 'Where:'
};